<div appScrollAnimation>
  <div class="mt-md-5 pt-md-5">
    <div class="container">
      <div class="parent-token-wrapper">

        <div class="upcoming-tokens">
          <p class="title">{{"coming" | translate}}</p>
          <h3 class="heading">
            {{"upcoming-tokens" | translate}}
          </h3>
          <div class="token-card">
            <div class="card-title">
              <span>Bitcoin Minetrix</span>
            </div>
            <div class="card-body">
              <div class="item-box">
                <img src="/assets/images/Minetrix.svg" alt="Minetrix">
                <div class="item-list">
                  <ul>
                    <li>Stake-to-Mine</li>
                    <li>{{"Price" | translate}}: $0.011</li>
                    <li>{{"Stage" | translate}} 1/10</li>
                  </ul>
                </div>
              </div>
              <div class="action-btn">
                <a href="https://bitcoinminetrix.com/en" target="_blank">{{"BUY-NOW" | translate}}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="trending-tokens">
          <p class="title">{{"coming" | translate}}</p>
          <h3 class="heading">
            {{ "trending-tokens" | translate}}
          </h3>
          <div class="token-card">
            <div class="card-body">
              <img src="assets/images/Group1.svg" alt="treding token img" />
            </div>
          </div>
        </div>

        <div class="token-airdrops">
          <p class="title">{{"coming" | translate}}</p>
          <h3 class="heading">
            {{"token-airdrops" | translate}}
          </h3>
          <div class="token-card">
            <div class="card-body">
              <div class="card-title">
                <span><img src="assets/images/latest-airdrop.svg" /> {{"Latest-Airdrops" | translate}} </span>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="div-content">
                    <img class="left-content" src="assets/images/Plasm-AI-logo.svg" alt="" />
                    <div class="list-name">Plasm AI</div>
                  </div>
                  <div class="div-content">
                    <img class="left-content" src="assets/images/axie-infinity-axs-logo.svg" alt="" />
                    <div class="list-name">Axie Infinity</div>
                  </div>
                  <div class="div-content">
                    <img class="left-content" src="assets/images/blur-airdrop-logo.svg" alt="" />
                    <div class="list-name">Blur</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="div-content">
                    <img class="left-content" src="assets/images/arb-airdrop2.svg" alt="" />
                    <div class="list-name">Arbitrum Foundation</div>
                  </div>
                  <div class="div-content">
                    <img class="left-content" src="assets/images/Script-Network-logo.svg" alt="" />
                    <div class="list-name">Script-Network</div>
                  </div>
                  <div class="div-content">
                    <img class="left-content" src="assets/images/TapiocaDAO-logo.svg" alt="" />
                    <div class="list-name">TapiocaDAO</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>